import { PAGEPATHS } from "components/Common/Constant"
import React, { useEffect, useState } from "react"
import { Row, Col, Card, CardBody } from "reactstrap"
import { useParams } from "react-router-dom" //
import { ApiNames } from '../../components/Common/ApiManagement/apiServices'
import "./datatables.scss"
import "./SearchEngine.css"
import axiosInstance from "components/Common/ApiManagement/axiosInstance";
import { TableHeader } from "components/Common/common";
import { setBreadcrumbItems } from "../../store/actions"
import { connect } from "react-redux"
import DataTableWithPopup from "components/longContentTable";
import {
  Search,
  Lightbulb,
  FileText,
  Info,
  CheckCircle,
  XCircle,
  TrendingUp,
  Database
} from 'lucide-react';

const SearchEngine = (props) => {
    document.title = "Search Engine";
    // const [scanId, setScanId] = useState(sessionStorage.getItem('scanId'))
    const { scanId: paramScanId } = useParams();
    const [scanId, setScanId] = useState(paramScanId || sessionStorage.getItem('scanId'));
    const [seoData, setSeoData] = useState({})
    const [searchFeatureData, setSearchFeatureData] = useState('')
    const [lightHouseDesktopData, setLightHouseDesktopData] = useState({
        columns: [
            {
                label: 'Performance Audit Type',
                field: 'audit',
                sort: 'asc',
                width: 150
            },
            {
                label: 'Score',
                field: 'score',
                sort: 'asc',
                width: 150
            },
            {
                label: 'Display Value',
                field: 'displayValue',
                sort: 'asc',
                width: 150
            },
            {
                label: 'Description',
                field: 'description',
                sort: 'asc',
                width: 150
            },
            {
                label: 'Details',
                field: 'details',
                sort: 'asc',
                width: 150
            },
        ]
    })

    const breadcrumbItems = [
        { title: "Scan List", link: PAGEPATHS.Scanlist },
        { title: sessionStorage.getItem('domain'), link: "#" },
        { title: "Search Engine", link: "#" }
    ]

    useEffect(() => {
        props.setBreadcrumbItems("Search Engine", breadcrumbItems)
    })

    useEffect(() => {
        const getLHDScanList = async () => {
            try {
                const { data } = await axiosInstance.get(`${ApiNames.FETCH_SEARCH_ENGINE_LHD_SCAN}/${scanId}`)
                data.data = data.data.map(obj => {
                    return Object.fromEntries(
                        Object.entries(obj).map(([key, value]) => [
                            key, typeof value === 'number' || typeof value === 'boolean'
                                ? value.toString()
                                : value === null
                                    ? 'NaN'
                                    : value
                        ])
                    );
                });
                setLightHouseDesktopData((prev) => ({
                    ...prev,
                    columns: prev.columns,
                    rows: data.data
                }))
            } catch (e) {
                console.error(e);
            }
        }
        getLHDScanList()
    }, [scanId])

    useEffect(() => {
        const fetchSeoData = async () => {
            try {
                const { data } = await axiosInstance.get(`${ApiNames.FETCH_SEO_SCAN}/${scanId}`)
                const valid = Object.entries(data.data).reduce((a, v) => {
                    a.columns.push({
                        label: v[0],
                        field: v[0],
                        sort: 'asc',
                        width: 150
                    })
                    if (typeof v[1] === 'boolean' || v[1] === 0) {
                        a.rows[0][v[0]] = v[1].toString()
                    } else if (v[1] === null) {
                        a.rows[0][v[0]] = 'NaN'
                    } else {
                        a.rows[0][v[0]] = v[1]
                    }
                    return a
                }, { columns: [], rows: [{}] })
                setSeoData(valid)
            } catch (e) {
                console.error(e);
            }
        }
        fetchSeoData()
    }, [scanId])

    useEffect(() => {
        const fetchSearchFeature = async () => {
            try {
                const { data } = await axiosInstance.get(`${ApiNames.FETCH_SEARCH_FEATURE_SCAN}/${scanId}`)
                if (data.status)
                    setSearchFeatureData(data.data['Search Type'])
            } catch (e) {
                console.error(e);
            }
        }
        fetchSearchFeature()
    }, [])

    const isSearchEnabled = searchFeatureData && searchFeatureData !== 'no search';

    return (
        <React.Fragment>
            <div className="search-engine-page">
                {/* Page Header */}
                <div className="search-engine-header">
                    <div className="search-engine-header-content">
                        <div className="search-engine-icon-wrapper">
                            <Search className="search-engine-icon" />
                        </div>
                        <div className="search-engine-header-text">
                            <h1>Search Engine Presence</h1>
                            <p>SEO analysis and search engine visibility assessment for {sessionStorage.getItem('domain')}</p>
                        </div>
                    </div>
                </div>

                {/* Info Section */}
                <div className="search-engine-info-box">
                    <div className="search-engine-info-header">
                        <div className="search-engine-info-icon-wrapper">
                            <Info className="search-engine-info-icon" />
                        </div>
                        <h3>About This Assessment</h3>
                    </div>
                    <div className="search-engine-info-content">
                        <p>
                            This assessment evaluates your website's search engine visibility, SEO optimization, and performance metrics.
                            It includes Lighthouse desktop performance audits and comprehensive SEO analysis.
                        </p>
                        <p>
                            Results help identify opportunities to improve your site's discoverability and ranking in search engines.
                        </p>
                    </div>
                </div>

                {/* Search Status Card */}
                <div className="search-status-card">
                    <div className="search-status-header">
                        <Search className="search-status-header-icon" />
                        <h3>Search Feature Status</h3>
                    </div>
                    <div className="search-status-content">
                        <div className={`search-status-icon-wrapper ${isSearchEnabled ? 'enabled' : 'disabled'}`}>
                            {isSearchEnabled ? (
                                <CheckCircle className="search-status-icon enabled" />
                            ) : (
                                <XCircle className="search-status-icon disabled" />
                            )}
                        </div>
                        <div className="search-status-text">
                            <div className="search-status-label">Search Functionality</div>
                            <div className={`search-status-value ${isSearchEnabled ? 'enabled' : 'disabled'}`}>
                                {searchFeatureData === 'no search' ? 'Not Enabled' : searchFeatureData || 'Unknown'}
                            </div>
                            <div className={`search-status-badge ${isSearchEnabled ? 'enabled' : 'disabled'}`}>
                                {isSearchEnabled ? (
                                    <>
                                        <CheckCircle className="search-status-badge-icon" />
                                        <span>Search Enabled</span>
                                    </>
                                ) : (
                                    <>
                                        <XCircle className="search-status-badge-icon" />
                                        <span>Search Disabled</span>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Summary Cards */}
                <div className="search-engine-summary">
                    <div className="search-engine-summary-card">
                        <div className="search-engine-summary-icon-wrapper blue">
                            <Lightbulb className="search-engine-summary-icon blue" />
                        </div>
                        <div className="search-engine-summary-content">
                            <h3>{lightHouseDesktopData.rows ? lightHouseDesktopData.rows.length : '0'}</h3>
                            <p>Lighthouse Audits</p>
                        </div>
                    </div>

                    <div className="search-engine-summary-card">
                        <div className="search-engine-summary-icon-wrapper green">
                            <TrendingUp className="search-engine-summary-icon green" />
                        </div>
                        <div className="search-engine-summary-content">
                            <h3>{seoData.columns ? seoData.columns.length : '0'}</h3>
                            <p>SEO Metrics</p>
                        </div>
                    </div>

                    <div className="search-engine-summary-card">
                        <div className="search-engine-summary-icon-wrapper purple">
                            <Database className="search-engine-summary-icon purple" />
                        </div>
                        <div className="search-engine-summary-content">
                            <h3>{isSearchEnabled ? 'Active' : 'Inactive'}</h3>
                            <p>Search Status</p>
                        </div>
                    </div>
                </div>

                {/* Lighthouse Desktop Data */}
                <div className="search-engine-data-section">
                    <div className="search-engine-section-header">
                        <Lightbulb className="section-header-icon" />
                        <h2>Lighthouse Desktop Performance</h2>
                        <span className="scan-id">Scan ID: {scanId}</span>
                    </div>
                    {lightHouseDesktopData && lightHouseDesktopData.rows && lightHouseDesktopData.rows.length > 0 ? (
                        <DataTableWithPopup noBottomColumns={false} thirdPartyData={lightHouseDesktopData} />
                    ) : (
                        <div className="search-engine-empty-state">
                            <Lightbulb className="search-engine-empty-icon" />
                            <p>No Lighthouse desktop data available</p>
                        </div>
                    )}
                </div>

                {/* SEO Data */}
                <div className="search-engine-data-section">
                    <div className="search-engine-section-header">
                        <TrendingUp className="section-header-icon" />
                        <h2>SEO Analysis</h2>
                        <span className="scan-id">Scan ID: {scanId}</span>
                    </div>
                    {seoData && seoData.rows && seoData.rows.length > 0 ? (
                        <DataTableWithPopup noBottomColumns thirdPartyData={seoData} />
                    ) : (
                        <div className="search-engine-empty-state">
                            <TrendingUp className="search-engine-empty-icon" />
                            <p>No SEO data available</p>
                        </div>
                    )}
                </div>
            </div>
        </React.Fragment >
    )
}
export default connect(null, { setBreadcrumbItems })(SearchEngine)